class OrderType {
  constructor(title) {
    this.title = title;
  }
}
export default {
  inject: ['load'],
  data() {
    return {
      allOrderTypes: [],
      orderType: new OrderType(''),
      allOrderTypesForOther: [],
    };
  },
  methods: {
    getListOfOrderTypes: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllOrderTypes').then(() => {
        if (this.$store.state.orderTypeModule.successFlag) {
          this.allOrderTypesForOther = this.$store.state.orderTypeModule.allOrderTypes;
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.orderTypeModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getListOfOrderTypes();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.orderTypeModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getListOfOrderTypes();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getAllOrderTypes: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllOrderTypes').then(() => {
        if (this.$store.state.orderTypeModule.successFlag) {
          this.allOrderTypes = this.$store.state.orderTypeModule.allOrderTypes;
          this.allOrderTypes.forEach((c) => (c.isEdit = false));
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.orderTypeModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getAllOrderTypes();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.orderTypeModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getAllOrderTypes();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    addOrderTypeFunction: function () {
      if (!this.orderType.title) {
        this.snackText = 'عنوان نحوه تجویز نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.orderType.title.replace(/\s/g, '').length) {
        this.snackText = 'عنوان نحوه تجویز نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('addOrderType', this.orderType).then(() => {
        if (this.$store.state.orderTypeModule.successFlag) {
          this.$refs.confirm.showConfirmDialog = false;
          this.showAddEditModal = false;
          this.disabelConfirm = false;
          this.snackText = ' نحوه تجویز با موفقیت اضافه شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
          if (this.load.val) {
            this.load.val = false;
          }
          this.orderType = new OrderType('');
          this.getAllOrderTypes();
        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.orderTypeModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.addOrderTypeFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.orderTypeModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.addOrderTypeFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getOrderTypeFunction: function (id) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getOrderType', id).then(() => {
        if (this.$store.state.orderTypeModule.successFlag) {
          this.orderType = this.$store.state.orderTypeModule.orderType;
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.orderTypeModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getOrderTypeFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.orderTypeModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getOrderTypeFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    editOrderTypeFunction: function () {
      if (!this.orderType.title) {
        this.snackText = 'عنوان نحوه تجویز نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.orderType.title.replace(/\s/g, '').length) {
        this.snackText = 'عنوان نحوه تجویز نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('editOrderType', this.orderType).then(() => {
        if (this.$store.state.orderTypeModule.successFlag) {
          this.$refs.confirm.showConfirmDialog = false;
          this.disabelConfirm = false;
          this.showAddEditModal = false;
          if (this.load.val) {
            this.load.val = false;
          }
          this.getAllOrderTypes();
          this.snackText = ' نحوه تجویز با موفقیت ویرایش شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
          this.orderType = new OrderType('');
        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.orderTypeModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.editOrderTypeFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.orderTypeModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.editOrderTypeFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    deleteOrderTypeFunction: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('deleteOrderType', this.orderTypeId).then(() => {
        if (this.$store.state.orderTypeModule.successFlag) {
          this.disabelConfirm = false;
          this.$refs.confirm.showConfirmDialog = false;
          if (this.load.val) {
            this.load.val = false;
          }
          this.getAllOrderTypes();
          this.snackText = ' نحوه تجویز با موفقیت حذف شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.orderTypeModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.deleteOrderTypeFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.orderTypeModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.deleteOrderTypeFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    showError: function () {
      this.snackText = this.$store.state.orderTypeModule.error;
      this.$refs.snackRef.snackModel = true;
      this.snackColor = '#FF5252';
      this.snakIcon = 'mdi-information';
    },
  },
};
